// Assessments
export const ASSESSMENTS_LANDING =
  "https://firebasestorage.googleapis.com/v0/b/vocab-buddy-53eca.appspot.com/o/assessments-landing.png?alt=media&token=168586ea-bb4e-499c-a711-5f3fe7a375b9";

// Assessments
export const INTERVENTIONS_LANDING =
  "https://firebasestorage.googleapis.com/v0/b/vocab-buddy-53eca.appspot.com/o/interventions-landing.png?alt=media&token=168586ea-bb4e-499c-a711-5f3fe7a375b9";

// Reward balloon
export const BALLOON =
  "https://firebasestorage.googleapis.com/v0/b/vocab-buddy-53eca.appspot.com/o/balloon.svg?alt=media&token=003857c8-e0d6-48a1-bf0d-63124db1b935";

export const ERROR_IMAGE =
  "https://firebasestorage.googleapis.com/v0/b/vocab-buddy-53eca.appspot.com/o/errorscreen_illustration.png?alt=media&token=601b55ee-6869-4d1b-b808-032d5902a8e6";
